export default {
  SET_ERROR_MESSAGE: (state, error_msg) => (state.error_msg = error_msg),
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_SUCCESS: (state, success) => (state.success = success),
  SET_CONSULTANTS: (state, consultants) => (state.consultants = consultants),
  SET_NEXT_CONSULTANTS_URL: (state, next_consultants_url) =>
    (state.next_consultants_url = next_consultants_url),
  SET_CONSULTANT: (state, consultant) => (state.consultant = consultant),
  SET_REQUESTED_CONSULATANT_ID: (state, id) =>
    (state.requested_consultant_id = id),
  SET_SHOULD_APPEND: (state, shouldAppend) =>
    (state.shouldAppend = shouldAppend),
};
